import React, { useEffect, useRef } from 'react';
import { usePressEscape } from '../../../../../hooks';
import { useSelector } from 'react-redux';
import { selectCurrentSelectedBooking } from '../../../../../selectors/scheduler';
import { EditDeadline } from '@hub-mono/app-modules';

export const EditDeadlineContextMenu = React.memo(({ top, left, close }) => {
    usePressEscape(close);
    const mountedRef = useRef(false);

    const currentSelectedBooking = useSelector(selectCurrentSelectedBooking);

    usePressEscape(close);

    useEffect(() => {
        const refTimeout = setTimeout(() => {
            mountedRef.current = true;
        }, 0);

        return () => {
            clearTimeout(refTimeout);
            mountedRef.current = false;
        };
    }, []);

    if (!currentSelectedBooking.booking) {
        return null;
    }

    return <EditDeadline isOpen onClose={close} position={{ left, top }} />;
});
